<template>
	<div class="messageDetailsOverlay" :class="{ fixed }" v-show="!!message" @click.self="$emit('close')">
		<div class="container p-0">
			<b-card class="m-3" no-body :class="message?.giftColorThreshold?.value && `gift-${message?.giftColorThreshold?.value}`">
				<template #header>
					<div class="float-right">
						<b-button-close size="sm" @click="$emit('close')"></b-button-close>
						<br />
						<b-spinner v-show="replyLoading > 0" label="Loading" class="spinner-border-xs"></b-spinner>
					</div>
					<b-avatar size="3rem" :src="message?.avatarUrl||message?.serviceIconUrl" v-if="message?.avatarUrl||message?.serviceIconUrl" class="mr-2 float-left"></b-avatar>
					{{message?.displayName}}
					<br v-if="message?.displayName"/>
					<b-avatar :src="message?.serviceIconUrl" v-if="message?.avatarUrl&&message?.serviceIconUrl" size="1rem" class="mr-1 service_avatar"></b-avatar>
					<small>{{message?.giftString}} {{message?.eventString}}</small>
				</template>
				<b-card-body ref="messageContent" />
				<b-card-body ref="messageMessages" v-if="message?.messages?.length > 0">
					<chat-message v-for="(m, i) in message?.messages" :key="i" :item="m" :serviceIcons="serviceIcons"/>
				</b-card-body>
				<div class="card-footer p-0">
					<div class="d-flex flex-wrap flex-column flex-sm-row">
						<a v-if="message?.isAlert" class="flex-grow-1 text-center btn btn-default btn-sm" href="#" @click.prevent="$emit('replay', message)"><b-icon-play/> Replay alert</a>
						<a class="flex-grow-1 text-center btn btn-default btn-sm" href="#" @click.prevent="$emit('select', message)" :class="{ 'highlighted': isHighlighted }">{{isHighlighted ? '⊖ Hide' : '⊕ Show'}}</a>
					</div>
				</div>
				<div class="card-footer" v-for="(url, idx) in message?.urls" :key="idx">{{url}}</div>
				<div class="card-footer p-1" v-if="message?.canReply">
					<b-input-group>
						<b-input v-model="replyText" placeholder="Reply..." :readonly="replyLoading > 0" autocomplete="off" @keyup.enter.prevent.stop="replyText && sendReply()"></b-input>
						<b-input-group-append>
							<b-button size="sm" variant="success" :disabled="!replyText || replyLoading > 0" @click="sendReply()">
								<svg fill="#000000" height="24px" width="24px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 495 495">
									<g>
										<path d="M164.711,456.687c0,2.966,1.647,5.686,4.266,7.072c2.617,1.385,5.799,1.207,8.245-0.468l55.09-37.616 l-67.6-32.22V456.687z"/>
										<path d="M492.431,32.443c-1.513-1.395-3.466-2.125-5.44-2.125c-1.19,0-2.377,0.264-3.5,0.816L7.905,264.422 c-4.861,2.389-7.937,7.353-7.904,12.783c0.033,5.423,3.161,10.353,8.057,12.689l125.342,59.724l250.62-205.99L164.455,364.414 l156.145,74.4c1.918,0.919,4.012,1.376,6.084,1.376c1.768,0,3.519-0.322,5.186-0.977c3.637-1.438,6.527-4.318,7.97-7.956 L494.436,41.257C495.66,38.188,494.862,34.679,492.431,32.443z"/>
									</g>
								</svg>
							</b-button>
						</b-input-group-append>
					</b-input-group>
				</div>
			</b-card>
		</div>
	</div>
</template>

<script>
import ChatMessage from '@/components/ChatMessage.vue';

export default {
	components: { ChatMessage },
	props: {
		message: Object,
		user: Object,
		serviceIcons: Object,
		fixed: { type: Boolean, default: false },
	},
	data() { return {
		replyText: '',
		replyLoading: 0,
	}},
	computed: {
		isHighlighted() {
			return !!(this.user?.highlighted_message &&
				String(this.message?.serviceId) == String(this.user.highlighted_message.serviceId) &&
				this.message?.token == this.user.highlighted_message.token);
		},
	},
	watch: {
		message(msg) {
			this.replyText = '';
			this.$nextTick(() => {
				if(!this.$refs.messageContent) return;
				while(this.$refs.messageContent.lastChild)
					this.$refs.messageContent.removeChild(this.$refs.messageContent.lastChild);
				if(msg?.spansDom?.length > 0) {
					this.$refs.messageContent.classList.remove('d-none');
					for(const span of msg.spansDom)
						this.$refs.messageContent.appendChild(span.cloneNode(true));
				} else {
					this.$refs.messageContent.classList.add('d-none');
				}
				if(msg?.mediaElem)
					this.$refs.messageContent.appendChild(msg.mediaElem);
			});
		},
	},
	methods: {
		async sendReply() {
			try {
				const text = this.replyText;
				this.replyText = '';
				this.replyLoading++;
				await this.$api.post('message', {
					serviceId: this.message.serviceId,
					channelToken: this.message.message?.target?.channelToken,
					chatToken: this.message.message?.target?.chatToken,
					message: text,
					replyTo: this.message.message?.token,
				});
			} catch(e) {
				console.error(e);
				this.$bvToast.toast('Could not send reply: ' + (e.error || e.toString()), {
					title: 'Error', variant: 'danger', solid: true,
				});
			} finally {
				this.replyLoading--;
			}
		},
	},
};
</script>

<style lang="scss">
@import '../plugins/variable.scss';

.messageDetailsOverlay {
	z-index: 200;
	overflow: auto;
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	background: rgba(255, 255, 255, .2);
	backdrop-filter: brightness(40%) saturate(50%) blur(3px);

	&.fixed {
		position: fixed;
		top: 0;
	}

	.service_avatar {
		width: 1rem;
		height: 1rem;
		margin-left: -1.5rem;
	}

	img { max-width: 100%; }

	.highlighted {
		background: $vaporwave-white !important;
		color: $dark;
	}
}
</style>
